export default {
	name: 'Gabriel Schneider',
	
	instagram_link: 'https://www.instagram.com/gabs_schneider/',
	medium_link: 'https://medium.com/@gabrielschneider_72533',
	messenger_link: 'https://m.me/gabriel.schneider.1840',
	whatsapp_link: 'https://api.whatsapp.com/send?phone=5515997953510',
	phone_number: '5515997953510',
	
	menu_info_name: 'Gabriel Schneider',
	menu_info_details: 'Mobile & Web Design and Development',
	menu_contact_email: 'contato@gabrielsch.com',
	menu_contact_cel: '+55 15 99795 3510',
	
	hero_greeting: 'HI.',
	hero_intro_title: 'My name is Gabriel Schneider',
	hero_intro_description: 
		'I design and develop apps, websites and smart things. '
		+ 'I help people and businesses launch their digital products, '
		+ 'analyze how well they are performing and trace strategies for '
		+ 'improvements and growth.',

	bio_title: {
		t1: 'Designer',
		t2: 'Developer',
		t3: 'Thinker'
	},
	bio_info_p1: 
		'Before I started developing apps professionally I studied abroad, '
		+ 'travelled and met new people from different countries. After some time trying '
		+ 'to figure out my place in the world, I realized I could use my technical and human knowledge to help '
		+ 'others achieve their goals and give life to their ideas.',
	bio_info_p2: 
		'Creating apps is not just about programming screens and features, there is a lot of preparation and '
		+ 'study that leads to the final product your users will receive. A product that is useful, lovable and fun '
		+ 'to use. Creating is an art, a science, a philosophy.',
	bio_info_p3: 
		'That is why being able to count with someone to assist you is essential to ensure your '
		+ 'product offers the best solution possible to your users. Your app or website are going to be '
		+ 'your digital connection with your customers, so it is worth to invest in a high quality solution.',
	bio_info_p4: 
		'I would love to help you with your projects and assist you in creating a unique and creative '
		+ 'digital experience for your costumers. Get in touch with me so we can talk about some cool '
		+ 'ideas.',				
	bio_action: 'GET IN TOUCH',

	project_intro_goal: 'Goal',
	project_intro_result: 'Result',
	project_links_web: 'Go to website',
	project_links_ios: 'Download on Apple Store',
	project_links_android: 'Download on Google Play',

	footer_info: '© 2018 Gabriel Schneider. All rights reserved.'
}


// WEBPACK FOOTER //
// ./src/values/strings/strings-en.js